import React from "react";
import styled from "styled-components";
import DelishopAppQrCode from "../../../../assets/images/delishop_app_qrcode.jpg";
import { Image } from "react-bootstrap";

function QrCodeMenu({ cartType }) {
	return (
		<QrCodeContainer>
			<div className="qrcode-image-content">
				<Image loading="lazy" src={DelishopAppQrCode} />
			</div>
			<div className="qrcode-description-content">
				<p>Scan to Download App </p>
				<p>IOS & Android</p>
			</div>
		</QrCodeContainer>
	);
}

const QrCodeContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 1rem;

	.qrcode-image-content {
		display: block;
		width: 14.375rem;
		height: 14.375rem;

		img {
			display: block;
			width: 100%;
			object-fit: contain;
			aspect-ratio: 1/1;
		}
	}

	.qrcode-description-content {
		border-top: 1px solid #979696;
		padding-top: 0.625rem;

		p {
			text-align: center;
			font-weight: 500;
		}
	}
`;

export default QrCodeMenu;
